// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"623b2b38","600":"623b2b38","684":"623b2b38","718":"623b2b38","960":"623b2b38"}[chunkId] + ".chunk.css";
};